// Global CSS shared by both apps (body reset, scrollbars, toast animations).
export const GlobalStyles = () => (
  <style>{`
    * { box-sizing: border-box; }
    html { min-width: 0; overflow-x: hidden; }
    body { margin: 0; padding: 0; overflow-x: hidden; background: var(--theme-secondary); }
    button, input, select, textarea { max-width: 100%; }
    table { border-collapse: collapse; }
    @supports (-moz-appearance: none) {
      * { scrollbar-width: thin; scrollbar-color: #e2e8f0 transparent; }
    }
    *::-webkit-scrollbar { width: 6px; height: 6px; }
    *::-webkit-scrollbar-track { background: transparent; }
    *::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }
    *::-webkit-scrollbar-thumb:hover,
    *::-webkit-scrollbar-thumb:active { background: #000000; }
    *::-webkit-scrollbar-button { display: none !important; width: 0 !important; height: 0 !important; opacity: 0 !important; }
    .table-scrollbar::-webkit-scrollbar-track { margin-top: 39px; margin-bottom: 2px; }
    @keyframes toast-in {
      0% { opacity: 0; transform: translate3d(22px, -8px, 0) scale(0.98); }
      100% { opacity: 1; transform: translate3d(0, 0, 0) scale(1); }
    }
    .animate-toast-in { animation: toast-in 0.24s ease-out both; }
    @keyframes toast-timer { from { width: 100%; } to { width: 0%; } }
    .animate-toast-timer { animation: toast-timer 3.2s linear forwards; }
    @media (max-width: 640px) {
      .custom-scrollbar { scrollbar-width: thin; }
      th, td { white-space: nowrap; }
      [role="dialog"], .fixed { max-width: 100vw; }
      footer[class*="justify-end"],
      footer[class*="justify-between"] {
        flex-wrap: wrap;
      }
      footer[class*="justify-end"] > button,
      footer[class*="justify-between"] > button {
        min-height: 40px;
      }
    }
  `}</style>
);
